<template>
  <div class="estimation-parameters">
    <div class="estimation-parameters__content">
      <div class="estimation-parameters__parameter-container">
        <div class="estimation-parameters__parameter">
          <div class="estimation-parameters__parameter-name">
            {{ $t('estimation.estimation-generation.source') }}
          </div>

          <div class="estimation-parameters__parameter-value">
            {{ extractionSlipSource.name }}
          </div>
        </div>
      </div>
      <div class="estimation-parameters__parameter-container">
        <div class="estimation-parameters__parameter">
          <div class="estimation-parameters__parameter-name">
            {{ $t('estimation.estimation-generation.product-bundle-title') }}
          </div>
          <div class="estimation-parameters__parameter-value">
            {{ productBundleTemplate.name }}
          </div>
        </div>
      </div>
      <div class="estimation-parameters__parameter-container">
        <div class="estimation-parameters__parameter">
          <div class="estimation-parameters__parameter-name">
            {{ $t('estimation.estimation-generation.export-model-title') }}
          </div>

          <div class="estimation-parameters__parameter-value">
            {{ extractionOutputFileTemplate.name }}
          </div>
        </div>
      </div>
      <div class="estimation-parameters__parameter-container">
        <div class="estimation-parameters__parameter">
          <div class="estimation-parameters__parameter-name">
            {{ $t('estimation.estimation-documents.parameters-dialog.created-at') }}
          </div>

          <div class="estimation-parameters__parameter-value">
            {{ formatStandardDate(productBundleExtraction.createdAt) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatStandardDate } from '@/util/date-util';
import { mapGetters } from 'vuex';

export default {
  name: 'EstimationParameters',
  computed: {
    ...mapGetters('productBundleExtraction', ['productBundleExtraction']),
    ...mapGetters('productBundleTemplates', ['productBundleTemplates']),
    ...mapGetters('extractionOutputFileTemplates', ['extractionOutputFileTemplates']),
    ...mapGetters('opportunityDocuments', ['opportunityDocuments']),
    productBundleTemplate() {
      return this.productBundleTemplates.find(
        (productBundleTemplate) => this.productBundleExtraction.productBundleTemplateId === productBundleTemplate.id,
      );
    },
    extractionOutputFileTemplate() {
      return this.extractionOutputFileTemplates.find(
        (extractionOutputFileTemplate) =>
          this.productBundleExtraction.extractionOutputFileTemplateId === extractionOutputFileTemplate.id,
      );
    },
    extractionSlipSource() {
      return this.opportunityDocuments.find(
        (opportunityDocument) => this.productBundleExtraction.opportunityDocumentId === opportunityDocument.id,
      );
    },
  },
  methods: {
    formatStandardDate,
  },
};
</script>

<style lang="scss">
.estimation-parameters {
  display: flex;
  flex-direction: column;

  &__content {
    overflow-y: auto;
    max-height: 50%;
  }

  &__parameter-container {
    display: flex;
    align-items: center;
    background: $color-neutral-pale;
    margin-bottom: 0.5rem;
  }

  &__parameter {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 0.5rem;
    border-radius: $border-radius-small;

    &-name {
      color: $color-normal-pale;
      font-size: 1rem;
      width: 250px;
      flex: 1;
      margin-right: 0.5rem;
    }

    &-value {
      font-size: 1rem;
      display: flex;
      flex: 1;
    }
  }
}
</style>
